import styled from 'styled-components';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';
import { cssVars } from '@/styles/Themes/cssVars';
import { radius, borders } from '@/styles/Themes/Metrics';
import { Pencil } from '@/shared/images/icons/Pencil';
import { Remove } from '@/shared/images/icons/Remove';
import { Cross } from '@/shared/images/icons/Cross';

export const Container = styled.div`
    width: 100%;
    max-width: 680px;
    margin-bottom: 20px;
`;

export const TopWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    background-color: ${cssVars.bg_ash_dark2};
    padding: 8px 20px 8px 8px;
    border-radius: 15px 15px 0 0;
    width: 100%;
    max-width: 680px;

    ${Screen.ipad} {
        padding: 12px 20px 12px 12px;
    }

    ${Screen.desktop} {
        padding: 40px 56px;
    }
`;

export const TopContainer = styled.div`
    display: flex;
    text-align: center;
`;

export const ImageThumb = styled.div`
    width: 88px;
    min-height: 88px;
    max-height: 88px;
    flex: none;
    margin-right: 12px;
    overflow: hidden;
    border-radius: 12px;
    ${Screen.ipad} {
        width: 120px;
        min-height: 120px;
        max-height: auto;
        margin-right: 16px;
    }
`;

export const StyledImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
    display: block;
`;

export const InnerWrap = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 4px 0;
`;

export const BottomWrapper = styled.div`
    text-align: center;
    background-color: ${cssVars.bg_ash_dark2};
    padding: 24px;
    border-radius: 0 0 15px 15px;
    width: 100%;
    max-width: 680px;

    ${Screen.ipad} {
        padding: 30px 42px;
    }

    ${Screen.desktop} {
        margin: 0 auto;
        padding: 40px 56px;
    }
`;

export const TicketTitle = styled.a`
    display: block;
    color: ${cssVars.fg_gray1_white};
    ${Text.Full.large.medium};
    text-align: left;
    text-decoration: none;
`;

export const TicketDate = styled.div`
    color: ${cssVars.fg_gray2_gray3};
    font-size: 14px;
    line-height: 1.5;
    text-align: left;
    display: block;
`;

export const DashedContainer = styled.div`
    position: relative;
    height: 0px;
    width: 100%;
    max-width: 680px;

    ${Screen.desktop} {
        margin: 0 auto;
    }
`;

export const DashedLine = styled.div`
    display: flex;
    width: 100%;
    position: relative;
    top: 12px;
    justify-content: space-between;

    ${Screen.ipad} {
        top: 14px;
    }
`;

export const CircleLeft = styled.div`
    width: 18px;
    height: 18px;
    background: ${cssVars.bg_white_blue};
    border-radius: ${radius.large};
    position: absolute;
    top: 4px;
    left: -3%;

    ${Screen.ipad} {
        height: 32px;
        width: 32px;
        top: -2px;
    }
    ${Screen.desktop} {
        background: ${cssVars.bg_white_dark3};
        width: 30px;
        height: 30px;
        left: -2%;
        top: 0;
    }
`;

export const CircleRight = styled.div`
    width: 18px;
    height: 18px;
    background: ${cssVars.bg_white_blue};
    border-radius: ${radius.large};
    position: absolute;
    top: 4px;
    right: -3%;

    ${Screen.ipad} {
        height: 32px;
        width: 32px;
        top: -2px;
    }
    ${Screen.desktop} {
        background: ${cssVars.bg_white_dark3};
        width: 30px;
        height: 30px;
        right: -2%;
        top: 0;
    }
`;

export const Divider = styled.span`
    display: inline-block;
    height: 2px;
    background-color: ${cssVars.bg_white_blue};
    width: 10%;
    margin: 0 8px;

    ${Screen.ipad} {
        margin: 0 16px;
    }

    ${Screen.desktop} {
        background: ${cssVars.bg_white_dark3};
        margin: 0 19px;
    }
`;

export const TicketAlignment = styled.div`
    display: flex;
    justify-content: space-between;
    border-bottom: ${borders.small} ${cssVars.bg_gray4_dark1};
`;

export const TextWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const TicketText = styled.div`
    color: ${cssVars.fg_gray1_white};
    ${Text.Mobile.large.medium};
    margin: 0 0 0 15px;
    padding: 15px 0;
    text-align: left;

    ${Screen.ipad} {
        ${Text.Full.medium.medium};
    }

    ${Screen.desktop} {
        margin: 18px 0 18px 20px;
        padding: 0;
    }
`;

export const BottomTicket = styled.div`
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
`;

export const SubTotalPromoText = styled.div`
    display: flex;
    justify-content: space-between;
    ${Text.Full.medium.medium};
    color: #0dd1c5;
    padding: 10px 0 0;
`;

export const SubTotalText = styled.div`
    display: flex;
    justify-content: space-between;
    ${Text.Full.large.medium};
    color: ${cssVars.fg_gray2_gray3};
    padding: 10px 0 0;
`;

export const SubTotalPromo = styled.div`
    color: #0dd1c5;
    ${Text.Full.medium.medium};
    margin: 0 0 0 12px;
`;

export const SubTotal = styled.div`
    color: ${cssVars.fg_gray1_white};
    ${Text.Full.large.medium};
    margin: 0 0 0 12px;
`;

export const TicketPrice = styled.div`
    color: ${cssVars.fg_gray1_white};
    ${Text.Full.large.medium};
    margin: auto 0 auto 10px;
`;

export const EventLink = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    color: ${cssVars.fg_gray2_gray3};
    padding: 10px 8px 0 0;
    ${Text.Mobile.large.medium};

    > svg {
        width: 14px;
        height: 14px;
        margin-bottom: 2px;
    }

    &:hover {
        color: ${cssVars.fg_gray1_white};
    }

    ${Screen.ipad} {
        ${Text.Full.medium.medium};
    }
`;

export const IconWrapper = styled.div`
    display: flex;

    > svg {
        width: 18px;
        height: 13px;
    }

    ${Screen.ipad} {
        > svg {
            width: 22px;
            height: 16px;
        }
    }
    ${Screen.desktop} {
        > svg {
            width: 22px;
            height: 22px;
        }
    }
`;

export const IconOptionWrapper = styled.div`
    display: flex;

    > svg {
        width: 15px;
        height: 15px;
    }

    ${Screen.ipad} {
        > svg {
            width: 18px;
            height: 18px;
        }
    }

    ${Screen.desktop} {
        > svg {
            width: 22px;
            height: 22px;
        }
    }
`;

export const LeftBottomContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    color: ${cssVars.fg_gray2_gray3};

    ${Screen.ipad} {
        justify-content: space-between;
    }
`;

export const RightBottomContainer = styled.span`
    display: flex;
    flex-direction: column;
    color: ${cssVars.fg_gray2_gray3};
`;

export const EditIcon = styled(Pencil)`
    height: 8px;
    width: 8px;

    ${Screen.desktop} {
        height: 11px;
        width: 11px;
    }
`;

export const RemoveIcon = styled(Remove)`
    height: 8px;
    width: 8px;

    ${Screen.desktop} {
        height: 13px;
        width: 13px;
    }
`;

export const CrossIcon = styled(Cross)`
    height: 6px;
    width: 6px;

    ${Screen.desktop} {
        height: 8px;
        width: 7px;
    }
`;

export const Policy = styled.div`
    color: ${cssVars.fg_gray2_gray3};
    ${Text.Full.medium.medium}

    display: inline-flex;
    margin: 8px 0 0 8px;
    text-decoration: underline;
    vertical-align: middle;
    text-align: start;

    *:first-child {
        flex-shrink: 0;
        margin-right: 8px;
    }
`;
